<template>
  <div>
    <base-header class="pb-6" type="">
      <div class="row align-items-center py-4">
        <breadcrumbs :header="$t('Student learning table')"></breadcrumbs>
      </div>
    </base-header>
    <v-wait :for="waitFor">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col">
            <div class="card bg-transparent">
              <el-table class="table-responsive"
                        header-row-class-name="thead-light"
                        :empty-text="$t('No any reviews for the student')"
                        :data="answers">
                <el-table-column :label="$t('Task title')" min-width="310px" prop="title">
                  <template v-slot="{row}">
                    {{ row.title }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('Status')" prop="status">
                  <template v-slot="{row}">
                    <badge v-if="row.status"
                           :type="row.status === 'done' ? 'success' : 'secondary'">
                      {{ $t(`reviewStatus.${row.status}`) }}
                    </badge>
                  </template>
                </el-table-column>
                <el-table-column min-width="100px">
                  <template v-slot="{row}">
                    <base-button
                      @click="doReview(row)"
                      v-if="row.status === 'need_review'">
                      Проверить
                    </base-button>
                  </template>
                </el-table-column>
              </el-table>
              <modal-review-task-answer
                v-if="modalAnswer && modalTask"
                v-model="modal"
                :answer="modalAnswer"
                :task="modalTask"
                @onCancel="cleanModal"
                @onSend="successModal"
                >
              </modal-review-task-answer>
            </div>
          </div>
        </div>
      </div>
    </v-wait>

  </div>
</template>

<script>
  import Breadcrumbs from "../../../Layout/Breadcrumbs";
  import {Table, TableColumn, Tooltip} from "element-ui";
  import Spinner from "vue-spinner-component/src/Spinner";
  import {createNamespacedHelpers} from 'vuex';
  const {mapActions} = createNamespacedHelpers('course/audience');
  import ModalReviewTaskAnswer from "../../../../components/Modals/ModalReviewTaskAnswer";
  import {getKebabToCamelDeepMap, tryExceptAwait} from "../../../../utils";
  import tasksEndpoints from "../../../../api/tasks";
  import audienceEndpoints from "../../../../api/audience";

  export default {
    name: "CourseAudienceStudent",
    metaInfo() {
      return {
        title: this.$i18n.t("audience.student.metaTitle",
          {student: this.student && this.student.name}
          )
      }
    },
    components: {
      ModalReviewTaskAnswer,
      Breadcrumbs,
      [Tooltip.name]: Tooltip,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Spinner
    },
    data() {
      return {
        waitFor: 'course student fetching',
        modal: false,
        modalAnswer: undefined,
        modalTask: undefined,
      }
    },
    computed: {
      student() {
        return this.$store.getters['course/audience/getStudent'](this.$route.params.studentId)
      },
      answers() {
        return this.$store.getters['course/audience/getStudentAnswers'](this.$route.params.studentId)
      }
    },
    async created() {
      if (!this.student) {
        await this.fetchData();
      }
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      ...mapActions({
        loadStudents: 'loadStudents',
        loadStudentsAnswers: 'loadStudentsAnswers',
      }),
      async fetchData() {
        this.$wait.start(this.waitFor);
        await this.loadStudents({urlParams: this.$route.params});
        await this.loadStudentsAnswers({urlParams: this.$route.params});
        this.$wait.end(this.waitFor);
      },
      async doReview(answer) {
        const taskUrlParams = {
          courseId: this.$route.params.courseId,
          taskId: answer.taskId,
          lessonId: answer.lessonId
        }
        const answerUrlParams = {
          courseId: this.$route.params.courseId,
          answerId: answer.id
        }
        const taskResponse = await tryExceptAwait(
          tasksEndpoints.getTask,
          [taskUrlParams]
        )
        if (taskResponse.status === 200 && taskResponse.data) {
          this.modalTask = getKebabToCamelDeepMap(taskResponse.data)
        }

        const answerResponse = await tryExceptAwait(
         audienceEndpoints.getStudentAnswer,
         [answerUrlParams]
        )
        if (answerResponse.status === 200 && answerResponse.data) {
          this.modalAnswer = {...answer, ...getKebabToCamelDeepMap(answerResponse.data)}
        }
        if (this.modalTask && this.modalAnswer) {
          this.modal = true
        } else {
          this.cleanModal();
        }
      },
      async successModal() {
        this.cleanModal();
        await this.fetchData();
      },
      cleanModal() {
        this.modalAnswer = undefined
        this.modalTask = undefined
        this.modal = false
      }
    }
  }
</script>

<style scoped>

</style>
